// extracted by mini-css-extract-plugin
export var standaloneTable = "_ev-0";
export var standaloneTableWithBodyFill = "_ev-1";
export var withExtraHeader = "_ev-2";